<template>
  <div class="Site PageBox" style="background-color: var(--background-main)">
    <van-nav-bar
      fixed
      :border="false"
      :title="$t('Finance[2]')"
      left-arrow
      style=""
      @click-left="$router.go(-1)"
    />
    <div v-if="infoData" class="ScrollBox" :class="{gray: infoData.state==3}">
      <div style="border-radius: 10px;overflow:hidden;margin: 0 12px;position:relative">
        <van-image :src="InitData.setting.up_url+infoData.cover_img" style="display:block" />
        <div class="mark" v-if="infoData.state==3">
          <img :src="`./static/icon/${$i18n.locale}/finance_state${infoData.state}.png`" height="90">
        </div>
      </div>
      <div class="con-box">
        <div class="money">
          <p>{{$t('Finance[3]')}}</p>
          <small>{{InitData.currency}}</small>{{$Util.KeepDecimal(Number(infoData.money)*formData.number,2)}}
        </div>
        <div class="title">
          {{infoData.title}}
        </div>
        <div class="info">
          <div v-if="infoData.daily_dividend">
            <label>{{$t('Finance[0][0]')}}</label>
            <span v-if="infoData.profit_multiple">{{Number(infoData.daily_dividend)}} x {{Number(infoData.profit_multiple)}} {{$t('Finance[0][4]')}} = {{InitData.currency}}{{$Util.KeepDecimal(Number(infoData.daily_dividend)*Number(infoData.profit_multiple),2)}}</span>
            <span v-else>{{InitData.currency}}{{Number(infoData.daily_dividend)}}</span>
          </div>
          <div v-if="infoData.equity">
            <label>{{$t('Finance[0][1]')}}</label>
            <span v-if="infoData.profit_multiple">{{Number(infoData.equity)}} x {{Number(infoData.profit_multiple)}} {{$t('Finance[0][4]')}} = {{InitData.currency}}{{$Util.KeepDecimal(Number(infoData.equity)*Number(infoData.profit_multiple),2)}}</span>
            <span v-else>{{InitData.currency}}{{Number(infoData.equity)}}</span>
          </div>
          <div v-if="infoData.options">
            <label>{{$t('Finance[0][2]')}}</label>
            <span v-if="infoData.profit_multiple">{{Number(infoData.options)}} x {{Number(infoData.profit_multiple)}} {{$t('Finance[0][4]')}} = {{InitData.currency}}{{$Util.KeepDecimal(Number(infoData.options)*Number(infoData.profit_multiple),2)}}</span>
            <span v-else>{{InitData.currency}}{{Number(infoData.options)}}</span>
          </div>
          <div v-if="infoData.subsidy">
            <label>{{$t('Finance[0][3]')}}</label>
            <span v-if="infoData.profit_multiple">{{Number(infoData.subsidy)}} x {{Number(infoData.profit_multiple)}} {{$t('Finance[0][4]')}} = {{InitData.currency}}{{$Util.KeepDecimal(Number(infoData.subsidy)*Number(infoData.profit_multiple),2)}}</span>
            <span v-else>{{InitData.currency}}{{Number(infoData.subsidy)}}</span>
          </div>
          <van-progress :percentage="infoData.schedule" stroke-width="12" color="var(--color-active)" />
          <div v-if="infoData.description" class="dec">{{infoData.description}}</div>
        </div>
      </div>
      <div class="con-box" style="padding: 0 8px">
        <div class="table-box">
          <table width="100%">
            <tbody>
              <tr v-for="item,index in infoData.income_model" :key="index">
                <td>
                  {{$t('Finance[4][0]')}}
                  <p>({{Number(item.profit)}}%)</p>
                </td>
                <td v-for="date,i in item.day" :key="i">
                  {{date.day}}{{$t('Finance[4][1]')}}
                  <div>{{Number(date.income)}}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="infoData.profit_multiple" class="table-mark">×{{Number(infoData.profit_multiple)}}</div>
      </div>
      <div class="con-box" v-html="infoData.content"></div>
      <div v-if="infoData.state==1" class="block-box"></div>
      <div v-if="infoData.state==1" class="submit-btn">
        <van-button type="danger" block round style="font-size:16px" @click="showSku=true">{{$t('Finance[5]')}}</van-button>
      </div>
    </div>
    <van-loading v-else size="60px" vertical style="margin-top: 50%">{{$t('dialog[6]')}}</van-loading>
    <van-popup
      v-model="showSku"
      round
      position="bottom"
      safe-area-inset-bottom
      :style="{height: 'auto'}"
    >
      <div class="SkuPopup" v-if="showSku">
        <van-grid :column-num="2" :border="false">
          <van-grid-item :text="Number(UserInfo.balance).toString()">
            <template slot="icon">
              {{$t('Finance[6][0]')}}({{InitData.currency}})
            </template>
          </van-grid-item>
          <van-grid-item :text="Number(infoData.money).toString()">
            <template slot="icon">
              {{$t('Finance[6][1]')}}({{InitData.currency}})
            </template>
          </van-grid-item>
        </van-grid>
        <van-cell :title="$t('Finance[6][2]')">
          {{InitData.currency}} <em>{{infoData.daily_dividend}}</em>
        </van-cell>
        <van-cell :title="$t('Finance[6][3]')">
          {{infoData.all_day}} {{$t('Finance[6][4]')}}
        </van-cell>
        <van-form @submit="submitOrder">
          <van-field v-show="false" name="fid" :value="financeId" readonly />
          <van-field v-model="formData.number" name="number" :label="$t('Finance[6][5]')" input-align="right">
            <template #input>
              <van-stepper 
                v-model="formData.number"
                min="1" 
                :max="infoData.num"
                input-width="90px"
                button-size="40px"
              />
            </template>
          </van-field>
          <div class="tips">
            {{$t('Finance[6][6]')}}: <i>{{infoData.num}}</i>, {{$t('Finance[6][7]')}}: {{InitData.currency}}<i>{{$Util.KeepDecimal(incomeVal*Number(infoData.profit_multiple||1),2)}}</i>
          </div>
          <div class="bottom">
            <van-button type="danger" round block style="font-size: 16px">{{$t('Finance[7]')}}</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Detail',
  components: {
    
  },
  props: ['financeId'],
  data() {
    return {
      infoData: '',
      showSku: false,
      formData: {
        number: 1
      },
      incomeVal: 0,
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.$Model.GetFinanceDetail({id: this.financeId},(data)=>{
      this.infoData = data
      const last_income_model  = data.income_model[data.income_model.length-1]
      const last_income = last_income_model.day[last_income_model.day.length-1]
      this.incomeVal = last_income.income
    })
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    submitOrder(json) {
      this.$Model.SubmitFinanceOrder(json,(data)=>{
        if(data.code==1){
          this.showSku = false
          this.$router.push('/financeOrder')
        }
      })
    },
  }
}
</script>
<style scoped>
.gray{
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}
.mark{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, .5);
}
.con-box {
  margin: 12px;
  background-color: var(--background-theme);
  border-radius: 10px;
  padding: 20px;
  line-height: 1;
  position: relative;
}
.con-box .money{
  text-align: center;
  font-size: 28px;
  color: var(--color-important);
}
.con-box .money p{
  font-size: 16px;
  margin-bottom: 10px;
  color: var(--color-main);
}
.con-box .title{
  font-size: 18px;
  text-align: center;
  margin: 15px 0;
}
.con-box .info>div{
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.con-box .dec{
  text-align: center;
  border-top: 1px #eee solid;
  padding-top: 15px;
  margin-top: 15px!important;
}
.van-progress{
  border-radius: 50px;
}
.van-progress>>>.van-progress__pivot{
  line-height: 1;
}
.table-box{
  line-height: 1;
  font-size: 12px;
  text-align: center;
  overflow-x: auto;
  padding: 8px 0;
}
.table-box tr+tr{
  border-top: 1px #ddd solid;
}
.table-box td+td{
  border-left: 1px #ddd solid;
}
.table-box td{
  padding: 6px 3px;
}
.table-box td p{
  margin-top: 5px;
}
.table-box td div{
  margin-top: 5px;
  color: var(--color-important);
}
.table-mark {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 120px;
  color: var(--color-important);
  opacity: .6;
  pointer-events: none;
}
.submit-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px;
}
.block-box{
  height: 70px;
}
.SkuPopup .van-grid{
  background-image: url('../../../public/static/images/default/task_bg.png'),linear-gradient(to right,#f83a3a,#fba030);
  background-repeat: no-repeat;
  background-size: 100%;
}
.SkuPopup .van-grid>>>.van-grid-item__content{
  background-color: transparent;
  color: rgba(255, 255, 255, .8);
  font-size: 12px;
  line-height: 1;
  padding: 20px 0;
  justify-content: space-between;
  text-align: center;
}
.SkuPopup .van-grid>>>.van-grid-item__text{
  font-size: 22px;
  margin-top: 10px;
  color: #fff;
}
.SkuPopup .van-cell{
  padding: 15px;
}
.SkuPopup>>>.van-cell__title{
  color: var(--color-assist);
}
.SkuPopup>>>.van-cell__value{
  color: var(--color-main);
}
.SkuPopup .van-cell__value input[type='password']{
  width: 55vw;
  border: 1px #eee solid;
  padding: 8px 5px;
  font-size: 13px;
  color: #333;
  border-radius: 3px;
}
.SkuPopup .van-stepper>>>.van-stepper__input{
  font-size: 18px;
  color: #333;
}
.SkuPopup .tips{
  color: var(--color-assist);
  font-size: 12px;
  padding: 10px 15px;
  line-height: 1;
  text-align: right;
}
.SkuPopup .tips i{
  color: var(--color-active);
}
.SkuPopup .bottom{
  padding: 15px;
}
</style>